type CleaningMapDisplaySetting = {
  degree: number;
  scale: number;
  baseWidth?: number;
  baseHeight?: number;
  offset: { x: number; y: number };
};

export const DEFAULT_DISPLAY_SETTING: CleaningMapDisplaySetting = {
  degree: 0,
  scale: 1,
  offset: { x: 0, y: 0 },
};

export type CleaningMapItem = {
  mapId: string;
  mapName: string;
  description?: string;
  displaySetting: CleaningMapDisplaySetting;
  enabled: boolean;
  exSrvCode: string;
};

export type CleaningMapList = CleaningMapItem[];
export type CleaningMapListResponse = CleaningMapList;
